import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["buttonLabels"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import WizardStep from './wizard-step';
import PropTypes from 'prop-types';
import Steps from "antd/es/steps/index.js";
import Modal from "antd/es/modal/index.js";
import Wizard from '@data-driven-forms/common/wizard/wizard';
import WizardContext from "@data-driven-forms/react-form-renderer/wizard-context";
var defaultButtonLabels = {
  cancel: 'Cancel',
  back: 'Back',
  next: 'Next',
  submit: 'Submit'
};
var Step = Steps.Step;

var WizardInternal = function WizardInternal(_ref) {
  var title = _ref.title,
      buttonLabels = _ref.buttonLabels,
      stepsInfo = _ref.stepsInfo,
      WizardProps = _ref.WizardProps,
      TitleProps = _ref.TitleProps,
      StepProps = _ref.StepProps,
      WizardStepProps = _ref.WizardStepProps,
      ButtonProps = _ref.ButtonProps,
      NextButtonProps = _ref.NextButtonProps,
      BackButtonProps = _ref.BackButtonProps,
      CancelButtonProps = _ref.CancelButtonProps,
      SubmitButtonProps = _ref.SubmitButtonProps,
      conditionalSubmitFlag = _ref.conditionalSubmitFlag;

  var _useContext = useContext(WizardContext),
      onKeyDown = _useContext.onKeyDown,
      formOptions = _useContext.formOptions,
      handleNext = _useContext.handleNext,
      handlePrev = _useContext.handlePrev,
      prevSteps = _useContext.prevSteps,
      currentStep = _useContext.currentStep,
      jumpToStep = _useContext.jumpToStep,
      activeStepIndex = _useContext.activeStepIndex;

  return /*#__PURE__*/React.createElement("div", _extends({
    onKeyDown: onKeyDown
  }, WizardProps), title && /*#__PURE__*/React.createElement(Modal, _extends({
    title: title,
    onCancel: formOptions.onCanel
  }, TitleProps)), stepsInfo && /*#__PURE__*/React.createElement(Steps, _extends({
    onChange: jumpToStep,
    current: activeStepIndex
  }, StepProps), stepsInfo.map(function (step, stepIndex) {
    return /*#__PURE__*/React.createElement(Step, _extends({
      disabled: activeStepIndex < stepIndex,
      step: stepIndex,
      key: stepIndex
    }, step));
  })), /*#__PURE__*/React.createElement(WizardStep, _extends({
    handleNext: handleNext,
    handlePrev: handlePrev,
    disableBack: prevSteps.length === 0,
    buttonLabels: buttonLabels
  }, currentStep, {
    formOptions: formOptions,
    WizardStepProps: WizardStepProps,
    ButtonProps: ButtonProps,
    NextButtonProps: NextButtonProps,
    BackButtonProps: BackButtonProps,
    CancelButtonProps: CancelButtonProps,
    SubmitButtonProps: SubmitButtonProps,
    conditionalSubmitFlag: conditionalSubmitFlag
  })));
};

WizardInternal.propTypes = {
  title: PropTypes.string,
  buttonLabels: PropTypes.object,
  stepsInfo: PropTypes.array,
  WizardProps: PropTypes.object,
  TitleProps: PropTypes.object,
  StepProps: PropTypes.object,
  WizardStepProps: PropTypes.object,
  ButtonProps: PropTypes.object,
  NextButtonProps: PropTypes.object,
  BackButtonProps: PropTypes.object,
  CancelButtonProps: PropTypes.object,
  SubmitButtonProps: PropTypes.object,
  conditionalSubmitFlag: PropTypes.string.isRequired
};

var WizardFinal = function WizardFinal(_ref2) {
  var buttonLabels = _ref2.buttonLabels,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Wizard, _extends({
    Wizard: WizardInternal,
    buttonLabels: _objectSpread(_objectSpread({}, defaultButtonLabels), buttonLabels)
  }, props));
};

WizardFinal.propTypes = {
  buttonLabels: PropTypes.object
};
export default WizardFinal;